module.exports = __webpack_public_path__ + "static/img/Two of Cups.1cd321a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Two of Cups.jpg
// module id = 1329
// module chunks = 0